module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', [_vm._v("Hello")]), _vm._v("\n  " + _vm._s(_vm.totalProduct) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ab620db0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/examples/APIExample.vue
// module id = 535
// module chunks = 1